module.exports = __webpack_public_path__ + "img/vedrana-skalic.50a820e9.jpg";